export default function getMoveAnimation (element, settings, animationcalculation) {
    const move = {
        y : 0,
        x : 0
    };


    if( settings.start_position ){
        const ownFontSize = element.data('fontsize') ?? 1
        // set y position
        if( settings.start_position.indexOf("top") > -1 ){
            move.y = getMovePositionTop(element, animationcalculation, ownFontSize)+"em";
        }else if( settings.start_position.indexOf("bottom") > -1 ){
            move.y = getMovePositionBottom(element, animationcalculation, ownFontSize)+"em";
        }

        // set x position
        if( settings.start_position.indexOf("left") > -1 ){
            move.x = getMovePositionLeft(element, animationcalculation, ownFontSize)+"em";
        }else if( settings.start_position.indexOf("right") > -1 ){
            move.x = getMovePositionRight(element, animationcalculation, ownFontSize)+"em";
        }
    }
    return move;
}

function getMovePositionTop(element, animationcalculation, ownFontSize){
    return -Math.ceil( element.outerHeight() + (element[0].getBoundingClientRect().top - animationcalculation.spread_rect.top) ) * animationcalculation.pxemratio / animationcalculation.scale / ownFontSize
}

function getMovePositionBottom(element, animationcalculation, ownFontSize){
    return Math.ceil(animationcalculation.spread_rect.bottom - element[0].getBoundingClientRect().top) * animationcalculation.pxemratio / animationcalculation.scale / ownFontSize
}

function getMovePositionLeft(element, animationcalculation, ownFontSize){
    return -Math.ceil(element.outerWidth() + element[0].getBoundingClientRect().left) * animationcalculation.pxemratio / animationcalculation.scale / ownFontSize
}

function getMovePositionRight(element, animationcalculation, ownFontSize){
    return Math.ceil( animationcalculation.container_width - element[0].getBoundingClientRect().left) * animationcalculation.pxemratio / animationcalculation.scale / ownFontSize
}
